import {getTexture} from "html-living-framework/lib/Utils/PixiUtils";
import {Emitter} from "pixi-particles";
import * as PIXI from "pixi.js";
import {SPRITESHEET_UI} from "../../../Data/Constants";

export class InteriorDancePartyMusicNotes extends PIXI.Container {

    private readonly _emitter!: Emitter;

    constructor() {
        super();
        this._emitter = new Emitter(this, [
            getTexture("music-note-01-02-02", SPRITESHEET_UI),
            getTexture("music-note-00-02-02", SPRITESHEET_UI),
        ], {
            alpha: {
                list: [
                    {value: 0, time: 0},
                    {value: 1, time: 0.2},
                    {value: 1, time: 0.8},
                    {value: 0, time: 1},
                ],
            },
            scale: {
                list: [
                    {value: 0.1, time: 0},
                    {value: 1, time: 1},
                ],
            },
            speed: {
                list: [
                    {value: 200, time: 0},
                    {value: 100, time: 1},
                ],
            },
            startRotation: {min: 0, max: 360},
            // minStartRotation: 0,
            // maxStartRotation: 360,
            lifetime: {min: 0.3, max: 0.8},
            frequency: 0.08,
            emitterLifetime: -1,
            maxParticles: 1000,
            pos: {x: 0, y: 0},
            addAtBack: false,
            spawnType: "rect",
            spawnRect: {x: 0, y: 0, w: 80, h: 140},
            blendMode: "normal",
            autoUpdate: true,
        });

        this.stopEmitting();
    }

    public startEmitting(): void {
        this._emitter.emit = true;
    }

    public stopEmitting(): void {
        this._emitter.emit = false;
    }

    public destroy(options?: PIXI.DestroyOptions | boolean) {
        this._emitter.destroy();
        super.destroy(options);
    }
}
